import { render } from "./SurveyCats.vue?vue&type=template&id=f2e8a900"
import script from "./SurveyCats.vue?vue&type=script&lang=js"
export * from "./SurveyCats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__